interface StreamConfig {
  page: string;
  hls: string;
  poster: string;
  label: string;
}

interface StreamUrls {
  [key: string]: StreamConfig;
}

export const STREAM_URLS: StreamUrls = {
  secure_ops1: {
    page: 'https://slack.westchesterrtc.com/stream/secure_ops1.html',
    hls: 'https://slack.westchesterrtc.com/hls/ops1/hdmi.m3u8',
    poster: '/images/rtcshield.png',
    label: 'Ops 1 Stream'
  },
  secure_ops2: {
    page: 'https://slack.westchesterrtc.com/stream/secure_ops2.html',
    hls: 'https://slack.westchesterrtc.com/hls/ops2/hdmi.m3u8',
    poster: '/images/rtcshield.png',
    label: 'RTC Apple TV'
  },
   secure_aviation: {
    page: 'https://slack.westchesterrtc.com/stream/secure_aviation.html',
    hls: 'https://slack.westchesterrtc.com/hls/aviation/hdmi.m3u8',
    poster: '/images/rtcshield.png',
    label: 'WCPD Aviation Air 3'
  },
  secure_air2: {
    page: 'https://slack.westchesterrtc.com/stream/secure_air2.html',
    hls: 'https://slack.westchesterrtc.com/hls/air2/hdmi.m3u8',
    poster: '/images/rtcshield.png',
    label: 'WCPD Aviation Air 2'
  }
};

export const API_ENDPOINTS = {
  validateStream: '/auth/validate_stream',
  validateGuacamole: '/auth/validate_guacamole_access',
  validateZello: '/validate_zello_access',
  guacamole: '/guacamole/',
  insight: '/insight',
  admin: '/admin'
};

export const IMAGE_PATHS = {
  header: '/images/RTC_Header_All.png',
  logo: '/images/RTC-blue_logo.png',
  shield: '/images/rtcshield.png'
};

export const ROUTES = {
  landing: '/',
  admin: '/admin',
  insight: '/insight',
  guacamole: '/guacamole',
  aviation: {
    stream1: '/aviation/stream1',
    stream2: '/aviation/stream2'
  }
}; 